<div class="file-upload-container">
  <div class="center flex image-content">
    <img *ngIf="fileInput" class="image" [src]="getFileUri()" />
    <mat-icon *ngIf="!fileInput" class="input-icon">
      {{ icon }}
    </mat-icon>
  </div>

  <div class="selected-file" *ngIf="fileInput">
    <a href="#" (click)="downloadFile($event)">
      {{ shortenFileName(fileInput.fileName) }}
    </a>
    <p>({{ fileInput.sizeInBytes! | fileSize }})</p>
  </div>

  <div class="buttons" *ngIf="!viewOnly && !fileInput">
    <input
      #file
      mat-raised-button
      type="file"
      (click)="file.value = ''"
      value=""
      accept="{{ validFileExtensions }}"
      (change)="addFile($event)"
      hidden
    />
    <button type="button" mat-raised-button value="Choose File" class="full-width-button" (click)="file.click()">
      {{ 'ACTIONS.UPLOAD' | translate }}
    </button>
  </div>

  <div class="icao-button-container">
    <button
      color="primary"
      *ngIf="!viewOnly && icaoValidation && fileInput"
      mat-raised-button
      type="button"
      class="full-width-button"
      (click)="openPhotoResultsDialog()"
    >
      {{ 'ICAO.SEE_RESULT' | translate }}
    </button>
  </div>

  <div class="remove-button-container" *ngIf="!viewOnly && fileInput">
    <button mat-raised-button color="warn" type="button" class="full-width-button" (click)="removeFile()">
      <mat-icon>delete</mat-icon>
      {{ 'ACTIONS.REMOVE' | translate }}
    </button>
  </div>

  <div *ngIf="!viewOnly && description && !fileInput">
    <label>{{ description }}</label>
  </div>
</div>
